import { Eye, X } from "lucide-react";
import { useAdminSimulation } from "@/shared/hooks/useAdminSimulation";
import { Button } from "@/shared/components/ui/button";

export function SimulationBanner() {
  const { isSimulating, simulationState, endSimulation } = useAdminSimulation();

  if (!isSimulating || !simulationState) return null;

  const formatDuration = () => {
    const elapsed = Date.now() - simulationState.startedAt;
    const minutes = Math.floor(elapsed / 60000);
    if (minutes < 1) return "just now";
    if (minutes === 1) return "1 minute";
    return `${minutes} minutes`;
  };

  return (
    <div className="bg-amber-500 text-amber-950 px-4 py-2 flex justify-between items-center sticky top-0 z-[100] shadow-md">
      <div className="flex items-center gap-3">
        <Eye className="w-5 h-5" />
        <div className="flex flex-col sm:flex-row sm:items-center sm:gap-2">
          <span className="font-semibold">
            Currently viewing user account: {simulationState.targetPersonName}
          </span>
          <span className="text-amber-800 text-sm">(Started {formatDuration()} ago)</span>
        </div>
      </div>
      <Button
        onClick={endSimulation}
        variant="outline"
        size="sm"
        className="bg-amber-950 text-amber-50 border-amber-950 hover:bg-amber-900 hover:text-amber-50"
      >
        <X className="w-4 h-4 mr-1" />
        Exit Simulation
      </Button>
    </div>
  );
}
